<!--
 * @Author: ZhaoG
 * @Date: 2025-04-28 18:00:46
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-09-11 15:08:13
 * @FilePath: \gcp-fe\src\app\procurementNotice\components\formSearch.vue
 * @Description: 采购公告--表单查询
-->
<template>
  <!-- 采购公告--表单查询 -->
  <div>
    <!--  -->
    <div class="search-panel">
      <el-form
        v-if="active != 5 && active != 6"
        :model="form"
        label-width="110px"
        class="formBox"
        label-position="left"
      >
        <!-- 公告类型 -->
        <el-form-item :label="$t('page.content.noticeTypeLabel')">
          <div class="btn-options">
            <el-button
              size="mini"
              v-for="(item, index) in typeOptions"
              :key="index"
              :type="isActive(item, index, 1)"
              :disabled="item.isNotLogin === '1'"
              @click="handleType(item, index, 1)"
              >{{ item.label }}
              <span v-if="item.isNotLogin === '1'">
                <i class="el-icon-warning-outline notice-warning-outline"></i
                ><span class="notice-warning-text">{{
                  $t("page.content.onlyLoginRequired")
                }}</span>
              </span>
            </el-button>
          </div>
        </el-form-item>

        <!-- 采购方式 -->
        <template v-if="typeActive != 7">
          <el-form-item :label="$t('page.content.purchaseType')">
            <el-menu
              ref="refMethodActive"
              :default-active="methodActive"
              class="el-menu-demo"
              mode="horizontal"
              style="border-bottom:0"
              @select="handleSelect"
            >
              <el-menu-item index="0">{{
                $t("page.content.all")
              }}</el-menu-item>
              <el-menu-item index="1" v-show="typeActive != 1">{{
                $t("page.content.publicBidding")
              }}</el-menu-item>
              <el-menu-item index="2" v-show="typeActive != 0">{{
                $t("page.content.invitationTender")
              }}</el-menu-item>
              <el-submenu index="3" popper-class="itemBox">
                <template slot="title">{{
                  $t("page.content.inquiryCompareShort")
                }}</template>
                <div class="btn-options">
                  <el-menu-item index="3001" :disabled="typeActive == 0">
                    <span>
                      {{ $t("page.content.invitationInquiryCompare") }}</span
                    >
                    <template v-if="!openId && typeActive == 0">
                      <i
                        class="el-icon-warning-outline notice-warning-outline iconBtn"
                      ></i>
                      <span class="notice-warning-text notice-warning-text1">{{
                        $t("page.content.onlyLoginRequired")
                      }}</span>
                    </template>
                  </el-menu-item>

                  <el-menu-item index="3002" :disabled="typeActive == 1">{{
                    $t("page.content.publicInquiryCompare")
                  }}</el-menu-item>
                </div>
              </el-submenu>
              <el-submenu index="4" popper-class="itemBox">
                <template slot="title">{{
                  $t("page.content.negotiationShort")
                }}</template>
                <div class="btn-options">
                  <el-menu-item index="4001" :disabled="typeActive == 0">
                    <span class="iconBtn">{{
                      $t("page.content.invitationNegotiation")
                    }}</span>
                    <template v-if="!openId && typeActive == 0">
                      <i
                        class="el-icon-warning-outline notice-warning-outline iconBtn"
                      ></i
                      ><span class="notice-warning-text notice-warning-text1">{{
                        $t("page.content.onlyLoginRequired")
                      }}</span>
                    </template>
                  </el-menu-item>
                  <el-menu-item index="4002" :disabled="typeActive == 1">{{
                    $t("page.content.publicNegotiation")
                  }}</el-menu-item>
                </div>
              </el-submenu>
              <el-submenu index="5" popper-class="itemBox" v-if="active != 4">
                <template slot="title">{{
                  $t("page.content.auctionShort")
                }}</template>
                <div class="btn-options">
                  <el-menu-item index="5001" :disabled="typeActive == 0"
                    ><span class="iconBtn">
                      {{ $t("page.content.inviteBidd") }}</span
                    >
                    <template v-if="!openId && typeActive == 0">
                      <i
                        class="el-icon-warning-outline notice-warning-outline iconBtn"
                      ></i
                      ><span class="notice-warning-text notice-warning-text1">{{
                        $t("page.content.onlyLoginRequired")
                      }}</span>
                    </template>
                  </el-menu-item>
                  <el-menu-item index="5002" :disabled="typeActive == 1">{{
                    $t("page.content.publicOutcry")
                  }}</el-menu-item>
                  <el-menu-item
                    index="5003"
                    :disabled="typeActive == 1"
                    v-if="active != 3"
                    >{{ $t("page.content.wasteMaterials") }}</el-menu-item
                  >
                </div>
              </el-submenu>
              <el-submenu
                index="6"
                popper-class="itemBox"
                v-if="typeActive != 1 && active != 4"
              >
                <template slot="title">{{
                  $t("page.content.otherProcurement")
                }}</template>
                <div class="btn-options">
                  <el-menu-item index="6001">{{
                    $t("page.content.openSingleSource")
                  }}</el-menu-item>
                  <el-menu-item index="6002">{{
                    $t("page.content.otherPathPublicBidding")
                  }}</el-menu-item>
                  <el-menu-item index="6003">{{
                    $t("page.content.offlinePublicInquiry")
                  }}</el-menu-item>
                  <el-menu-item index="6004">{{
                    $t("page.content.openCollaboration")
                  }}</el-menu-item>
                </div>
              </el-submenu>
              <el-submenu
                index="7"
                popper-class="itemBox"
                v-if="typeActive != 1 && active != 4"
              >
                <template slot="title">{{
                  $t("page.content.directProcurement")
                }}</template>
                <div class="btn-options">
                  <el-menu-item index="7">{{
                    $t("page.content.publicDirectProcurement")
                  }}</el-menu-item>
                </div>
              </el-submenu>
            </el-menu>
          </el-form-item>
        </template>

        <!-- 发布时间 -->
        <el-form-item :label="$t('page.content.publishTime')">
          <div
            class="typeBoxItem"
            v-for="(item, index) in formOptions.timeOptions"
            :key="index"
            @click="handleType(item, index, 3)"
            :class="{ active: index == timeActive }"
          >
            {{ item.label }}
          </div>
        </el-form-item>
        <template v-if="showAdvanced">
          <!-- 采购分类 -->
          <template v-if="active == 1 || active == 2 || active == 3">
            <el-form-item
              :label="$t('page.content.procurementCategory')"
              v-if="typeActive == 0 || typeActive == 1"
            >
              <div
                class="typeBoxItem"
                v-for="(item, index) in purchaseCategoryOptions"
                :key="index"
                @click="handleType(item, index, 4)"
                :class="{ active: index == shopActive }"
              >
                {{ item.dicValue }}
              </div>
            </el-form-item>
          </template>
          <!-- 物资分类 -->
          <template v-if="active == 1 || active == 2">
            <el-form-item
              :label="$t('page.content.materialClassify')"
              ref="goodsBox"
              class="goodsBox"
              v-if="typeActive == 0 || typeActive == 1"
            >
              <div
                :class="{ active: goodActive == -1 }"
                class="itemBox"
                @click="(goodActive = -1), (form.matBigClassesList = [])"
              >
                {{ $t("page.content.all") }}
              </div>
              <div class="flexBox">
                <span
                  v-for="(item, index) in matBigClassesOptions"
                  :key="index"
                >
                  <el-button
                    size="mini"
                    class="btnItemBox"
                    :class="[
                      {
                        'button-show': item.isShow /*多选 选中时的样式*/
                      },
                      'ellipsis'
                    ]"
                    :type="isActive(item, index, 2)"
                    @click="handleType(item, index, 11)"
                    >{{ item.label }}</el-button
                  >
                  <a @click="handleItemDel(item)"
                    ><b v-show="item.isShow"><i class="el-icon-close"></i></b
                  ></a>
                </span>
              </div>
              <div>
                <el-button
                  v-if="!isMultiSelect"
                  class="btnBox"
                  type="text"
                  @click="handleMultiSelect"
                  >{{ $t("page.content.multiSelect") }}</el-button
                >
                <div v-else class="btnsBox">
                  <el-button
                    class="btnBox"
                    size="mini"
                    type="primary"
                    @click="handleConfirm"
                    >{{ $t("page.content.sure") }}</el-button
                  >
                  <el-button class="btnBox" size="mini" @click="handleCancel">{{
                    $t("page.content.cancel")
                  }}</el-button>
                </div>
              </div>
            </el-form-item>
          </template>
          <!-- 分包类型 -->
          <template v-if="active == 4">
            <el-form-item
              :label="$t('page.content.subcontractingTypeLabel')"
              v-if="typeActive == 0 || typeActive == 1"
            >
              <div
                class="typeBoxItem"
                v-for="(item, index) in fenBaoLeiXingOptions"
                :key="index"
                @click="handleType(item, index, 7)"
                :class="{ active: index == fenBaoActive }"
              >
                {{ item.dicValue }}
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('page.content.category')"
              v-if="typeActive == 0 || typeActive == 1"
              ref="goodsBox"
              class="goodsBox"
              :style="{ height: goodsHeight }"
            >
              <div
                :class="{ active: gongChengActive == -1 }"
                class="itemBox itemBox1"
                @click="
                  (gongChengActive = -1), (form.subcontractingCategoryList = [])
                "
              >
                {{ $t("page.content.all") }}
              </div>
              <div
                class="goodsBoxItem"
                :style="{ height: goodsHeight, overflow: 'hidden' }"
              >
                <!-- <div class="typeBoxItem" v-for="(item, index) in formOptions.categoryOptions" :key="index" -->
                <div
                  class="typeBoxItem"
                  v-for="(item, index) in gongChengLeiBieOptions"
                  :key="index"
                  @click="handleType(item, index, 10)"
                  :class="{ active: index == gongChengActive }"
                >
                  <!-- <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                      {{ item.subjectName }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item, indexs) in item.data" :key="indexs">{{ item }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown> -->

                  {{ item.subjectName }}
                  <!-- <div
                  class="typeBoxItem"
                  v-for="(item, index) in gongChengLeiBieOptions"
                  :key="index"
                  @click="handleType(item, index, 10)"
                  :class="{ active: index == gongChengActive }"
                > 
                  {{ item.dicValue }}-->
                </div>
              </div>

              <el-button
                class="btnBox"
                type="text"
                @click="handleChangeHight"
                >{{
                  isProvinceCollapsed
                    ? $t("page.content.collapse")
                    : $t("page.content.expand")
                }}</el-button
              >
            </el-form-item>
          </template>

          <!-- 省市 -->
          <el-form-item
            :label="$t('page.content.provinceCity')"
            ref="provincesBox"
            class="provincesBox"
            :style="{ height: provincesHeight }"
            v-show="typeActive == 1 || typeActive == 0"
          >
            <div
              :class="{ active: provincesActive == 0 }"
              class="itemBox itemBox2"
              @click="(provincesActive = 0), (form.provinceList = [])"
            >
              {{ $t("page.content.all") }}
            </div>
            <div
              class="provincesBoxItem"
              :style="{ height: provincesHeight, overflow: 'hidden' }"
            >
              <span
                v-for="(item, index) in provinceOptions"
                :key="index"
                @click="handleType(item, index, 8)"
                :class="{ active: index + 1 == provincesActive }"
              >
                {{
                  language == "en-gb" ? item.addressEnName : item.addressName
                }}
              </span>
            </div>
            <el-button
              class="btnBox"
              type="text"
              @click="handleChangeHightpProvinces"
              >{{
                isProvinceCollapsed0
                  ? $t("page.content.collapse")
                  : $t("page.content.expand")
              }}</el-button
            >
          </el-form-item>

          <!-- 采购组织单位 -->
          <el-form-item
            :label="$t('page.content.procurementOrg')"
            v-if="active == 4 && openId && (typeActive == 0 || typeActive == 1)"
            ref="orgBox"
            class="orgBox goodsBox"
            :style="{ height: orgHeight }"
          >
            <div
              :class="{ active: orgActive == -1 }"
              class="itemBox itemBox1"
              @click="(orgActive = -1), (form.opUnitId = '')"
            >
              {{ $t("page.content.all") }}
            </div>
            <div
              class="goodsBoxItem"
              :style="{ height: orgHeight, overflow: 'hidden' }"
            >
              <div
                class="typeBoxItem"
                v-for="(item, index) in orgOptions"
                :key="index"
                @click="handleType(item, index, 20)"
                :class="{ active: index == orgActive }"
              >
                <el-popover
                  ref="popover"
                  placement="bottom"
                  trigger="click"
                  popper-class="custom-popover"
                  :visible-arrow="false"
                  :append-to-body="false"
                  :popper-options="{
                    positionFixed: true
                  }"
                >
                  <div class="popover-content">
                    <template v-if="item.list.length > 0">
                      <div
                        v-for="(subItem, indexs) in item.list"
                        :key="indexs"
                        class="popover-item"
                        @click="handleSubItemClick(subItem)"
                      >
                        {{ subItem.orgAbbrName }}
                      </div>
                    </template>
                    <div v-else class="popover-item">
                      {{ $t("page.content.noData") }}
                    </div>
                  </div>
                  <span slot="reference" class="popover-trigger">
                    {{ item.orgAbbrName
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                </el-popover>
              </div>
            </div>

            <el-button
              class="btnBox"
              type="text"
              @click="handleChangeHightOrg"
              >{{
                isProvinceCollapsedOrg
                  ? $t("page.content.collapse")
                  : $t("page.content.expand")
              }}</el-button
            >
          </el-form-item>
          <!-- 是否海外采购 -->
          <template
            v-if="
              active == 0 ||
                active == 1 ||
                active == 2 ||
                active == 3 ||
                active == 4
            "
          >
            <el-form-item
              :label="$t('page.content.isOverseasPurchase')"
              v-if="typeActive == 0 || typeActive == 1"
            >
              <div class="typeBoxItem">
                <el-radio-group v-model="form.overseasPurchaseFlag">
                  <el-radio :label="-1">{{ $t("page.content.all") }}</el-radio>
                  <el-radio :label="1">{{
                    $t("page.content.yesValue")
                  }}</el-radio>
                  <el-radio :label="0">{{
                    $t("page.content.noValue")
                  }}</el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
          </template>
          <!-- 状态 -->
          <template v-if="typeActive != 7">
            <el-form-item
              :label="$t('page.content.status')"
              v-if="typeActive == 1 || typeActive == 0"
            >
              <div
                class="typeBoxItem"
                v-for="(item, index) in formOptions.statusOptions"
                :key="index"
                @click="handleType(item, index, 9)"
                :class="{ active: index == statusActive }"
              >
                {{ item.label }}
              </div>
            </el-form-item>
            <el-form-item
              :label="$t('page.content.status')"
              v-else-if="typeActive == 2 || typeActive == 3"
            >
              <div
                class="typeBoxItem"
                v-for="(item, index) in formOptions.statusOptions0"
                :key="index"
                @click="handleType(item, index, 9)"
                :class="{ active: index == statusActive }"
              >
                {{ item.label }}
              </div>
            </el-form-item>
          </template>

          <!-- 公告名称 搜索框 -->
          <el-form-item :label="$t('page.content.noticeTitle')">
            <div class="typeBoxItemGg">
              <el-input
                :placeholder="$t('page.content.pleaseEnterTheTitle')"
                v-model="keyword"
                clearable
              >
              </el-input>
              <el-button
                type="text"
                @click="handleSearch"
                class="btnSearchBox"
                >{{ $t("page.content.search") }}</el-button
              >
            </div>
          </el-form-item>
        </template>
      </el-form>
      <el-button
        v-if="active != 5 && active != 6"
        type="text"
        @click="showAdvanced = !showAdvanced"
        class="btnBoxShow"
      >
        {{
          showAdvanced
            ? $t("page.content.advancedSearchCollapse")
            : $t("page.content.advancedSearchExpand")
        }}
      </el-button>
    </div>
    <!-- 表格展示 -->
    <template
      v-if="(typeActive == 0 || typeActive == 1) && active != 5 && active != 6"
    >
      <tableView
        :active="active"
        ref="tableView"
        :noticeTime="noticeTime"
        :form="form"
      ></tableView>
    </template>
    <template v-else-if="typeActive == 7 && active != 5 && active != 6">
      <notice-list
        :noticeType="form.noticeType"
        :noticeTime="noticeTime"
        ref="noticeList"
        :noticeTitle="form.noticeTitle"
      >
      </notice-list>
    </template>
    <EvaluateList
      v-else-if="
        (typeActive == 2 || typeActive == 3) && active != 5 && active != 6
      "
      :form="form"
      ref="EvaluateList"
      :noticeTime="noticeTime"
      :active="active"
    >
    </EvaluateList>
    <EvaluateListLast
      v-else-if="
        (typeActive == 4 || typeActive == 5 || typeActive == 6) &&
          active != 5 &&
          active != 6
      "
      :form="form"
      ref="EvaluateListLast"
      :noticeTime="noticeTime"
      :active="active"
    >
    </EvaluateListLast>
  </div>
</template>

<script>
import createFormOptions from "../js/formOptions";
import Cookies from "js-cookie";
import {
  qryMatcateryTreeList,
  qryAllProvince,
  getQueryDictionaryListApi,
  selectSubconSecondConfigList,
  select3LevelUnitByPartyId
} from "@/app/shop/api/shoppingSP";
import moment from "moment";
import tableView from "./table.vue";
import NoticeList from "../../shop/components/notice-list.vue";
import EvaluateList from "./evaluate-list.vue";
import EvaluateListLast from "./evaluate-list-last.vue";
import {
  selectFirstLevelSubjectCode,
  selectSubconBaseSubjectNewList
} from "../api/shopping.js";

export default {
  props: {
    active: {
      type: Number,
      default: 0
    }
  },
  components: { tableView, NoticeList, EvaluateList, EvaluateListLast },
  data() {
    return {
      formOptions: createFormOptions(),
      language: "",
      moment,
      typeActive: this.$route.query.type ? this.$route.query.type - 1 : 0,
      methodActive: "0",
      timeActive: 0,
      shopActive: 0,
      goodActive: -1,
      wuziActive: "0",
      serviceActive: 0,
      servicesActive: 0,
      fenBaoActive: 0,
      gongChengActive: -1,
      orgActive: -1,
      provincesActive: 0,
      statusActive: "",
      goodsHeight: "auto",
      provincesHeight: "auto",
      orgHeight: "auto",
      form: {
        noticeType: this.$route.query.type ? this.$route.query.type : 1, //公告类型
        overseasPurchaseFlag: -1, //是否海外采购
        provinceList: [], //省市
        matBigClassesList: [], //物资分类
        purchaseCategoryList: [], //采购分类
        mergePurchaseTypeList: [], //融合采购方式
        subcontractingTypeList: [], //工程分包-分包类型
        subcontractingCategoryList: [], //工程分包-类别
        singUpStatus: "", //状态
        opUnitId: "", //组织单位
        noticeTitle: "", //公告标题
        keyWord: sessionStorage.getItem("searchName") || ""
        // keyWord: this.$route.query.name
      },
      noticeTime: [], //发布时间
      isProvinceCollapsed: true,
      isProvinceCollapsedOrg: true,
      isProvinceCollapsed0: true,
      showAdvanced: false,
      orgOptions: [], //工程分包-组织机构
      openId: "",
      matBigClassesOptions: [], //物资分类
      purchaseCategoryOptions: [], //采购分类
      provinceOptions: [], //省市
      isMultiSelect: false,
      moreList: [], //多选
      noticeTitle: "",
      keyword: "",
      fenBaoLeiXingOptions: [], //分包类型
      gongChengLeiBieOptions: [] //工程分包-类别
    };
  },
  computed: {
    typeOptions() {
      if (this.active === 4) {
        let option = JSON.parse(JSON.stringify(this.formOptions.typeOptions));
        let options = option.slice(0, -1);
        options.map(item => {
          if (item.isNotLogin && !Cookies.get("access_token")) {
            item.isNotLogin = "1";
          }
        });
        return options;
      }
      return this.formOptions.typeOptions;
    }
  },
  watch: {
    active: {
      handler(newVal, oldVal) {
        // 联合采购(5)和海外采购(6)使用父组件独立表格，formSearch不需要处理
        if (newVal == 5 || newVal == 6) return;
        // 重置所有状态
        this.resetAllState();
        // 重新获取数据
        this.initData();
      },
      immediate: true
    }
  },

  mounted() {
    if (sessionStorage.getItem("searchName")) {
      this.form.keyWord = sessionStorage.getItem("searchName");
    } else {
      this.form.keyWord = "";
    }
    // if (this.$route.query.name) {
    //   this.form.keyWord = this.$route.query.name;
    // }
    this.openId = Cookies.get("access_token");
    this.language = Cookies.get("language");

    this.getMatcateryTreeList();
    // 查询全部省份
    this.getQryAllProvince();
  },
  methods: {
    // 获取采购方式
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      key === "0"
        ? (this.form.mergePurchaseTypeList = [])
        : (this.form.mergePurchaseTypeList = [key]);
    },

    changeRecent(value) {
      let endTime = moment(new Date()).format("YYYY-MM-DD");
      let startTime = moment(
        new Date().getTime() - Number(value) * 1000 * 24 * 60 * 60
      ).format("YYYY-MM-DD");
      return [startTime, endTime];
    },
    handleType(item, index, num) {
      switch (num) {
        case 1:
          this.typeActive = index;
          this.form.noticeType = item.value;
          this.form.noticeTitle = "";
          this.keyword = "";
          break;
        case 3:
          this.timeActive = index;
          if (this.timeActive == 0) {
            this.noticeTime = [];
          } else {
            this.noticeTime = this.changeRecent(item.value);
          }
          break;
        case 4:
          this.shopActive = index;
          if (item.dicValue !== "全部") {
            this.form.purchaseCategoryList = [item.dicKey];
          } else {
            this.form.purchaseCategoryList = [];
          }
          break;
        case 7:
          this.fenBaoActive = index;
          if (item.dicValue !== "全部") {
            this.form.subcontractingTypeList = [item.dicKey];
          } else {
            this.form.subcontractingTypeList = [];
          }
          break;
        case 8:
          this.provincesActive = index + 1;
          this.form.provinceList = [item.addressCode];
          break;
        case 9:
          this.statusActive = index;
          this.form.singUpStatus = item.value;
          break;
        case 10:
          this.gongChengActive = index;
          this.handleCommandOption(item, "item");
          this.form.subcontractingCategoryList = [item.subjectCode];
          break;
        case 20:
          this.orgActive = index;
          this.handleCommand(item, "item");
          this.form.opUnitId = item.orgId;
          break;
        case 11:
          this.goodActive = index;
          if (this.isMultiSelect) {
            this.$set(item, "isShow", true);
            this.moreList.push(item);
          } else {
            this.$set(item, "isShow", false);
            this.form.matBigClassesList = [item.value];
          }
          break;

        default:
          break;
      }
    },
    // 省市
    getQryAllProvince() {
      qryAllProvince({ languageFlag: Cookies.get("language") }).then(res => {
        // console.log(res);
        if (res.data.code == 0) {
          this.provinceOptions = res.data.data;
        }
      });
    },
    // 分包类型
    getFenBaoLeiXingOptions() {
      this.fenBaoLeiXingOptions = [];
      getQueryDictionaryListApi({
        code: "SUBCONTRACT_TYPE"
      }).then(res => {
        if (res.data.code == "0") {
          this.fenBaoLeiXingOptions = res.data.data;
          let arr = {
            dicValue: "全部",
            dicKey: ""
          };
          this.fenBaoLeiXingOptions.unshift(arr);
        }
      });
    },

    handleCommand(command) {
      // console.log(command, "command");
      select3LevelUnitByPartyId({ partyId: command.partyId }).then(res => {
        if (res.data.code == "0") {
          this.$set(command, "list", res.data.data);
        }
      });
    },
    handleCommandOption(item) {
      selectSubconBaseSubjectNewList({ subjectCode: item.subjectCode }).then(
        res => {
          // console.log(res, "res");
          if (res.data.code == "0") {
            res.data.data.filter(items => {
              return (items.parentCode = item.subjectCode);
            });
            // console.log(childrenData, "childrenData");
          }
        }
      );
    },
    // 工程分包-一级类别
    getGongChengLeiBieOptions() {
      this.gongChengLeiBieOptions = [];
      selectFirstLevelSubjectCode().then(res => {
        if (res.data.code == "0") {
          this.gongChengLeiBieOptions = res.data.data;
        } else {
          this.gongChengLeiBieOptions = [];
        }
      });
    },
    // 查询分包的组织机构(所有二级单位)
    getSelectSubconSecondConfigList() {
      this.orgOptions = [];
      selectSubconSecondConfigList().then(res => {
        // console.log(res, "查询分包的组织机构(所有二级单位) ");
        if (res.data.code == "0") {
          res.data.data.forEach(item => {
            item.list = [];
          });
          this.orgOptions = res.data.data;
        } else {
          this.orgOptions = [];
        }
      });
    },
    // 采购分类
    getPurchaseCategoryOptions() {
      this.purchaseCategoryOptions = [];
      getQueryDictionaryListApi({
        code: "PURCHASE_CATEGORY"
      })
        .then(res => {
          res.data.data.forEach(item => {
            if (this.active == 1) {
              if (
                item.dicKey == "0" ||
                item.dicKey == "1" ||
                item.dicKey == "4"
              ) {
                this.purchaseCategoryOptions.push(item);
              }
            } else if (this.active == 2) {
              if (
                item.dicKey == "0" ||
                item.dicKey == "1" ||
                item.dicKey == "2" ||
                item.dicKey == "3" ||
                item.dicKey == "5" ||
                item.dicKey == "7"
              ) {
                this.purchaseCategoryOptions.push(item);
              }
            } else {
              if (item.dicKey == "6" || item.dicKey == "8") {
                this.purchaseCategoryOptions.push(item);
                // this.form.purchaseCategory = this.form.purchaseCategory
                //   ? this.form.purchaseCategory
                //   : this.purchaseCategoryOptions[0].dicKey;
              }
            }
          });
          let allData = {
            dicKey: "",
            dicValue: "全部"
          };
          this.purchaseCategoryOptions.unshift(allData);
        })
        .catch(error => {
          console.log(error.msg);
        });
    },
    getMatcateryTreeList() {
      //查询物资分类
      qryMatcateryTreeList({
        parentMatcateryCode: "00"
      }).then(res => {
        if (res.data.code === "0") {
          res.data.data.map(item => {
            this.matBigClassesOptions.push({
              label: item.matcateryName,
              value: item.matcateryCode,
              isShow: false
            });
          });
        }
      });
    },

    isActive(item, index, i) {
      if (i == 1) {
        if (this.typeActive == index) {
          return "table-top-active";
        } else {
          return "table-top";
        }
      } else if (i == 2) {
        if (!this.isMultiSelect) {
          if (this.goodActive == index) {
            return "table-top-active";
          } else {
            return "table-top";
          }
        } else {
          if (this.goodActive == index && item.isShow) {
            return "table-top-active";
          } else {
            return "table-top";
          }
        }
      }
    },
    handleConfirm() {
      this.form.matBigClassesList = this.moreList.map(item => {
        return item.value;
      });
    },

    handleMultiSelect() {
      this.isMultiSelect = true;
    },
    handleCancel() {
      this.isMultiSelect = false;
      this.moreList = [];
      this.matBigClassesOptions.forEach(item => {
        item.isShow = false;
      });
      this.goodActive = -1;
    },
    //多选取消选中
    handleItemDel(item) {
      for (let i = 0; i < this.moreList.length; i++) {
        if (this.moreList[i].value === item.value) {
          this.moreList.splice(i, 1);
          break;
        }
      }
      this.$set(item, "isShow", false);
      if (this.moreList.length === 0) {
        this.goodActive = -1;
      }
    },
    handleChangeHightpProvinces() {
      this.isProvinceCollapsed0 = !this.isProvinceCollapsed0;
      // 通过 ref 获取元素
      const label = this.$refs.provincesBox.$el.querySelector(
        ".el-form-item__label"
      );
      if (!this.isProvinceCollapsed0) {
        this.$nextTick(() => {
          this.provincesHeight = "50px";
          label.style.height = "50px";
        });
      } else {
        this.$nextTick(() => {
          this.provincesHeight = "auto";
          label.style.height = "auto";
        });
      }
    },
    handleChangeHight() {
      this.isProvinceCollapsed = !this.isProvinceCollapsed;
      // 通过 ref 获取元素
      const label = this.$refs.goodsBox.$el.querySelector(
        ".el-form-item__label"
      );
      if (!this.isProvinceCollapsed) {
        this.$nextTick(() => {
          this.goodsHeight = "50px";
          label.style.height = "50px";
        });
      } else {
        this.$nextTick(() => {
          this.goodsHeight = "auto";
          label.style.height = "auto";
        });
      }
    },
    handleChangeHightOrg() {
      this.isProvinceCollapsedOrg = !this.isProvinceCollapsedOrg;
      // 通过 ref 获取元素
      const label = this.$refs.orgBox.$el.querySelector(".el-form-item__label");
      if (!this.isProvinceCollapsedOrg) {
        this.$nextTick(() => {
          this.orgHeight = "50px";
          label.style.height = "50px";
        });
      } else {
        this.$nextTick(() => {
          this.orgHeight = "auto";
          label.style.height = "auto";
        });
      }
    },
    handleSearch() {
      this.form.noticeTitle = this.keyword;
      if (this.$refs.tableView) {
        this.$refs.tableView.init();
      }
      if (this.$refs.EvaluateList) {
        this.$refs.EvaluateList.init();
      }
      if (this.$refs.EvaluateListLast) {
        this.$refs.EvaluateListLast.init();
      }
      if (this.$refs.noticeList) {
        this.$refs.noticeList.getNoticeList();
      }
    },
    handleSubItemClick(subItem) {
      // 关闭所有 popover
      this.$refs.popover.forEach(popover => {
        if (popover && typeof popover.doClose === "function") {
          popover.doClose();
        }
      });
      // 这里可以添加其他处理逻辑
      this.form.opUnitId = subItem.orgId;
    },
    resetAllState() {
      // 重置表单数据
      this.form = {
        noticeType: this.$route.query.type ? this.$route.query.type : 1,
        overseasPurchaseFlag: -1,
        provinceList: [],
        matBigClassesList: [],
        purchaseCategoryList: [],
        mergePurchaseTypeList: [],
        subcontractingTypeList: [],
        subcontractingCategoryList: [],
        singUpStatus: "",
        opUnitId: "",
        noticeTitle: "",
        keyWord: sessionStorage.getItem("searchName") || ""
        // keyWord: this.$route.query.name
      };

      // 重置所有激活状态
      this.typeActive = this.$route.query.type ? this.$route.query.type - 1 : 0;
      this.methodActive = "0";
      this.$nextTick(() => {
        if (this.$refs.refMethodActive) {
          this.$refs.refMethodActive.updateActiveIndex("0");
        }
      });
      this.timeActive = 0;
      this.shopActive = 0;
      this.goodActive = -1;
      this.fenBaoActive = 0;
      this.gongChengActive = -1;
      this.orgActive = -1;
      this.provincesActive = 0;
      this.statusActive = "";

      // 重置展开/收起状态
      this.showAdvanced = false;
      this.isProvinceCollapsed = true;
      this.isProvinceCollapsedOrg = true;
      this.isProvinceCollapsed0 = true;

      // 重置高度
      this.goodsHeight = "auto";
      this.provincesHeight = "auto";
      this.orgHeight = "auto";

      // 重置其他状态
      this.noticeTime = [];
      this.keyword = "";
      this.isMultiSelect = false;
      this.moreList = [];
    },

    initData() {
      // 根据 active 重新获取数据
      if (this.active == 1 || this.active == 2 || this.active == 3) {
        this.getPurchaseCategoryOptions();
      } else if (this.active == 4) {
        this.getFenBaoLeiXingOptions();
        this.getGongChengLeiBieOptions();
        this.getSelectSubconSecondConfigList();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-panel {
  padding: 20px 0;
  background: #fff;

  .formBox {
    border-bottom: 1px solid #ebeef5;

    .typeBoxItem,
    .itemBox {
      margin: 0 20px;
    }

    .itemBox {
      width: 52px;
    }

    .itemBox1 {
      width: 26px;
    }

    .itemBox2 {
      width: 45px;
    }

    .active {
      color: #0089ef;

      /deep/ .el-dropdown {
        color: #0089ef;
      }
    }

    .typeBoxItemGg {
      display: flex;
      align-items: center;
      position: relative;
      margin: 0 20px;

      /deep/ .el-input {
        width: 445px;
        // padding-top: 10px;
      }
      /deep/ .el-input__suffix {
        right: 35px;
      }
    }
  }

  /deep/.el-form-item__content {
    display: flex;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #4a4a4a;
    cursor: pointer;
    border-left: 1px solid #ebeef5;
    // justify-content: space-around;
  }

  /deep/ .el-form-item {
    margin-bottom: 0;
    // height: 50px;
    line-height: 50px;
    border-top: 1px solid #ebeef5;
    margin-right: 0;
  }

  /deep/ .el-form-item__content,
  /deep/.el-form-item__label {
    line-height: 50px;
  }

  /deep/ .el-form-item__label {
    padding-left: 15px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 13px;
    color: #666666;
  }

  /deep/ .el-menu--horizontal > .el-menu-item {
    height: 50px;
    line-height: 50px;
    color: #4a4a4a;
  }

  /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 50px;
    line-height: 50px;
    color: #4a4a4a;
  }

  /deep/ .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 0;
  }

  /deep/ .el-menu--horizontal > .el-menu-item.is-active {
    color: #0089ef;
  }

  .goodsBox {
    //   /deep/ .el-form-item__label {
    //     height: 100px;
    //   }

    /deep/ .el-form-item__content {
      display: flex;
      align-items: flex-start;
    }

    .btnBox {
      margin: 5px 40px 0 0;
    }

    .btnItemBox {
      margin-right: 20px;
    }

    .flexBox {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      overflow: "hidden";
    }

    .btnsBox {
      width: 70px;
    }

    .button-show {
      border: 1px solid #0089ef;
      position: relative;
      width: 90px;
      color: #0089ef;
      display: inline-block;
      text-align: left;
      padding-left: 12px;
      margin-right: 0;
    }

    b {
      background-color: #0089ef;
      color: #ffffff;
      width: 30px;
      display: inline-block;
      line-height: 34px;
      text-align: center;
      margin-right: 10px;
      padding-top: 1px;
    }
  }

  .provincesBox {
    /deep/ .el-form-item__label {
      height: 200px;
    }

    /deep/ .el-form-item__content {
      display: flex;
      align-items: flex-start;
    }

    .btnBox {
      margin: 5px 40px 0 0;
    }
  }

  .goodsBoxItem {
    width: 915px;
    display: flex;
    flex-wrap: wrap;
  }

  .provincesBoxItem {
    width: 915px;

    span {
      display: inline-block;
      margin-right: 30px;
    }
  }

  .btnBoxShow {
    width: 100%;
    text-align: center;
  }

  .mt20 {
    margin-top: 20px;
  }

  .btnSearchBox {
    position: absolute;
    left: 396px;
  }
}

/deep/ .el-button.el-button--table-top {
  font-weight: 400;
}

/deep/ .el-button.el-button--table-top-active {
  border: none;
  font-weight: 400;
}

.btn-options /deep/ .el-button {
  margin: 0 20px;
}

.notice-warning-text {
  display: none;
  vertical-align: super;
}

.btn-options /deep/ .is-disabled {
  color: #4a4a4a;
  opacity: 0.5;

  :hover {
    .notice-warning-outline {
      color: #d50a0c;
    }

    .notice-warning-text {
      color: #d50a0c;
      display: inline-block;
    }
  }
}

.notice-warning-outline {
  font-size: 14px;
  vertical-align: super;
}

.iconBtn {
  vertical-align: middle;
}

.iconBtn:hover + .notice-warning-text {
  color: #d50a0c;
  display: inline-block;
  vertical-align: middle;
}

/deep/ .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: #0089ef;
}

/deep/ .custom-popover {
  min-width: 120px;
  padding: 0;

  .popover-content {
    max-height: 200px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      background-color: #f5f5f5;
    }
  }

  .popover-item {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    color: #606266;

    &:hover {
      background-color: #f5f7fa;
      color: #0089ef;
    }
  }
}

.popover-trigger {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  color: inherit;
}
</style>
